import dayjs from "dayjs"
import { DateOnly } from "../@client/System"

export const dateToDateOnly = (date: Date) =>
  dayjs(date).format("YYYY-MM-DD") as DateOnly
